"use strict";

define('uikit/collections/steps',['underscore', 'marionette', '../channel', '../mixins/component.mixin', '../templates'], function (_, Mn, channel, ComponentMixin, Templates) {
  var Step = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'step',
    template: Templates.UIKit['step'],
    options: {
      active: false,
      completed: false,
      description: '',
      disabled: false,
      icon: '',
      link: false,
      text: '',
      title: ''
    },
    bindings: {
      active: 'active',
      completed: 'completed',
      disabled: 'disabled',
      title: 'title',
      text: 'text',
      description: 'description',
      icon: 'icon',
      link: 'link'
    },
    updateAttributes: function updateAttributes() {
      this.addClass('active', this.getBoolOption('active')).addClass('completed', this.getBoolOption('completed')).addClass('disabled', this.getBoolOption('disabled')).addClass('link', this.getBoolOption('link'));
    }
  });
  var Steps = Mn.CollectionView.extend(ComponentMixin).extend({
    className: 'ui steps',
    childView: Step,
    options: {
      autoSize: true,
      fluid: false,
      ordered: false,
      size: '',
      tabletResponsive: false,
      vertical: false
    },
    activateAtIndex: function activateAtIndex(nextStep) {
      var numOfSteps = this.children.length;
      if (nextStep < 0 || nextStep > numOfSteps - 1) {
        throw new Error(nextStep + ' is an invalid step index.');
      }
      for (var s = 0, len = numOfSteps; s < len; s++) {
        var step = this.getStep(s);
        if (s < nextStep) {
          step.completed = true;
          step.active = false;
          step.disabled = false;
        } else if (s == nextStep) {
          step.active = true;
          step.completed = false;
          step.disabled = false;
        } else if (s > nextStep) {
          step.disabled = true;
          step.active = false;
          step.completed = false;
        }
      }
      if (nextStep == numOfSteps - 1) {
        this.getStep(nextStep).active = false;
        this.getStep(nextStep).completed = true;
      }
    },
    getStep: function getStep(index) {
      return this.children.findByIndex(index);
    },
    getSizeClass: function getSizeClass() {
      var len = this.children.length || (this.collection ? this.collection.length : 0);
      return ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight'][len] || '';
    },
    updateAttributes: function updateAttributes() {
      this.addClass(this.getSizeClass(), this.getBoolOption('autoSize')).addClass('fluid', this.getBoolOption('fluid')).addClass('ordered', this.getBoolOption('ordered')).addClass(this.getOption('size'), this.getBoolOption('size')).addClass('tablet stackable', this.getBoolOption('tabletResponsive')).addClass('vertical', this.getBoolOption('vertical'));
    }
  });
  channel.reply('steps', function () {
    return Steps;
  });
  return Steps;
});

